<template>
  <el-tooltip :placement="placement" :raw-content="rawContent">
    <template #content>
      <slot name="content">{{ tooltipContent }}</slot>
    </template>
    <i class="ico el-icon-warning-outline tooltip-icon"></i>
  </el-tooltip>
</template>

<script>
export default {
  name: 'FormItemITooltip',
  props: {
    tooltipContent: {
      type: String,
      required: false
    },
    placement: {
      type: String,
      required: false,
      default: 'right'
    },
    rawContent: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>
i {
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/FormItemITooltip.vue